export const dl = `
    dd {
        margin-inline-start: unset;
    }  
`